// assets/uc-cart-drawer-sync.js
(() => {
  const SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];

  function log(...args) {
    console.log('[UC CART SYNC]', ...args);
  }

  async function parseJsonSafe(res) {
    try {
      return await res.json();
    } catch {
      return null;
    }
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  async function fetchSectionsOnly() {
    const res = await fetch(`/?sections=${SECTION_IDS.join(',')}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    const json = await parseJsonSafe(res);
    if (!res.ok || !json) {
      throw new Error('Failed to fetch cart sections.');
    }

    return {
      id: null,
      sections: json
    };
  }

  async function renderCartDrawer(parsedState, options = {}) {
    const { open = true } = options;
    const drawer = getCartDrawer();

    if (!drawer || typeof drawer.renderContents !== 'function') {
      log('cart drawer not found or renderContents missing');
      return;
    }

    drawer.renderContents(parsedState);

    if (!open) {
      drawer.close?.();
    }
  }

  async function refreshDrawer(options = {}) {
    const parsedState = await fetchSectionsOnly();
    await renderCartDrawer(parsedState, options);
    return parsedState;
  }

  async function cartRequest(url, body, options = {}) {
    const { openDrawer = true } = options;

    const payload = {
      ...body,
      sections: SECTION_IDS,
      sections_url: window.location.pathname
    };

    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const json = await parseJsonSafe(res);

    if (!res.ok) {
      const message =
        json?.description ||
        json?.message ||
        `Request failed: ${res.status}`;
      throw new Error(message);
    }

    if (json?.sections) {
      await renderCartDrawer(json, { open: openDrawer });
    } else {
      await refreshDrawer({ open: openDrawer });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:update'));

    return json;
  }

  async function addItems(items, options = {}) {
    return cartRequest('/cart/add.js', { items }, options);
  }

  async function changeLine(idOrKey, quantity, options = {}) {
    return cartRequest('/cart/change.js', { id: idOrKey, quantity }, options);
  }

  async function updateCart(updates, options = {}) {
    return cartRequest('/cart/update.js', { updates }, options);
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    const json = await parseJsonSafe(res);
    if (!res.ok || !json) {
      throw new Error('Failed to fetch cart.');
    }
    return json;
  }

  window.UCCartDrawerSync = {
    addItems,
    changeLine,
    updateCart,
    refreshDrawer,
    renderCartDrawer,
    getCart
  };
})();